module.exports = __webpack_public_path__ + "img/introduce-special.91e5fbb9.png";